export enum SyncAction {
    Insert = 'INSERT',
    Delete = 'DELETE',
    Update = 'UPDATE',
}
